var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    stroke: "#5A6078"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.96875H8.48437L8.90625 7.8125H3.42187L3 6.96875ZM3.5625 8.65625H9.04687L9.46875 9.5H3.98437L3.5625 8.65625ZM12.7031 13.1562C13.17 13.1562 13.5469 12.7794 13.5469 12.3125C13.5469 11.8456 13.17 11.4688 12.7031 11.4688C12.2362 11.4688 11.8594 11.8456 11.8594 12.3125C11.8594 12.7794 12.2362 13.1562 12.7031 13.1562ZM13.5469 8.09375H12.1406V9.5H14.6494L13.5469 8.09375ZM7.07812 13.1562C7.545 13.1562 7.92187 12.7794 7.92187 12.3125C7.92187 11.8456 7.545 11.4688 7.07812 11.4688C6.61125 11.4688 6.23437 11.8456 6.23437 12.3125C6.23437 12.7794 6.61125 13.1562 7.07812 13.1562ZM13.8281 7.25L15.5156 9.5V12.3125H14.3906C14.3906 13.2463 13.6369 14 12.7031 14C11.7694 14 11.0156 13.2463 11.0156 12.3125H8.76562C8.76562 13.2463 8.00625 14 7.07812 14C6.14437 14 5.39062 13.2463 5.39062 12.3125H4.26562V10.3438H5.39062V11.1875H5.81812C6.1275 10.8444 6.5775 10.625 7.07812 10.625C7.57875 10.625 8.02875 10.8444 8.33812 11.1875H11.0156V6.125H4.26562C4.26562 5.50063 4.76625 5 5.39062 5H12.1406V7.25H13.8281Z",
    fill: "#5A6078"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.0d8b4f7dd77aa70de3a84e9ae6260677.svg";
export { ForwardRef as ReactComponent };